import React from "react";
import RiskOverview from "../../../components/risk/RiskOverview";
import RiskRegisterTab from "../../../components/risk/RiskRegisterTab";
// Risk Masters moved to Organisation → Masters tab (see OrgMasters).
import RiskAssessments from "../../../components/risk/RiskAssessments";
import RiskVulnerabilities from "../../../components/risk/RiskVulnerabilities";
import RiskPrograms from "../../../components/risk/RiskPrograms";
import CadenceRuleList from "../../../components/cadence/CadenceRuleList";
import { CADENCE_MODULE_TYPES } from "../../../components/cadence/cadenceModuleTypes";
import ComingSoon from "../../../components/common/ComingSoon";
import "../../../components/layout/ModuleLayout.css";
import { RiskTabKey } from "./RiskTabs";

interface RiskNetBodyProps {
  activeTab?: RiskTabKey;
}

const RiskNetBody: React.FC<RiskNetBodyProps> = ({ activeTab = "overview" }) => {
  const renderPanel = () => {
    if (activeTab === "overview") return <RiskOverview />;
    if (activeTab === "register") return <RiskRegisterTab />;
    if (activeTab === "assessment") return <RiskAssessments />;
    if (activeTab === "vulnerabilities") return <RiskVulnerabilities />;
    if (activeTab === "programs")        return <RiskPrograms />;
    if (activeTab === "cadence")         return <CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.risk} />;
    return <ComingSoon />;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default RiskNetBody;
